import { computed, defineComponent } from "@vue/composition-api";
import { useIncomeHistoryHelpers } from "@Client/@Composables/application-standalone/pages/income-history/useIncomeHistoryHelpers";
import SummarySectionLayout from "./summary-section-layout.vue";
import { useAdditionalIncomeHelpers } from "@Client/@Composables/application-standalone/pages/additional-income/useAdditionalIncomeHelpers";
export default defineComponent({
  name: "IncomeHistorySection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      employmentSummarySubtitle,
      applicantHasEmployment,
      isIncomeHistorySectionVisibleForMainApplicant,
      isIncomeHistorySectionVisibleForCoApplicants
    } = useIncomeHistoryHelpers();
    const {
      applicantHasAdditionalIncome,
      additionalIncomeSummarySubtitle,
      additionalIncomeVisibleMainApplicant,
      additionalIncomeVisibleCoApplicants
    } = useAdditionalIncomeHelpers();
    const sectionVisibilityValues = computed(() => ({
      mainApplicant: isIncomeHistorySectionVisibleForMainApplicant.value || additionalIncomeVisibleMainApplicant.value,
      coApplicants: isIncomeHistorySectionVisibleForCoApplicants.value || additionalIncomeVisibleCoApplicants.value
    }));
    const additionalIncomeVisibleByApplicant = applicantIndex => {
      return applicantIndex === 0 ? additionalIncomeVisibleMainApplicant.value : additionalIncomeVisibleCoApplicants.value;
    };
    return {
      employmentSummarySubtitle,
      applicantHasEmployment,
      applicantHasAdditionalIncome,
      additionalIncomeSummarySubtitle,
      sectionVisibilityValues,
      additionalIncomeVisibleByApplicant
    };
  }
});